import { AlertTriangle } from 'lucide-react';
import { differenceInDays } from 'date-fns';

export default function StaleIndicator({ lastReviewedAt }) {
    if (!lastReviewedAt) return null;

    const daysSince = differenceInDays(new Date(), new Date(lastReviewedAt));
    if (daysSince < 365) return null;

    let severity = 'warning';
    if (daysSince > 730) severity = 'error';
    else if (daysSince > 545) severity = 'warning';

    const colors = {
        warning: { bg: 'rgba(240,173,78,0.1)', border: 'rgba(240,173,78,0.3)', color: '#f0ad4e' },
        error: { bg: 'rgba(255,107,107,0.1)', border: 'rgba(255,107,107,0.3)', color: '#ff6b6b' },
    };

    const c = colors[severity];

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: c.bg,
            border: `1px solid ${c.border}`,
            borderRadius: '6px',
            padding: '0.5rem 0.75rem',
            marginBottom: '1rem',
            color: c.color,
            fontSize: '0.8rem',
        }}>
            <AlertTriangle size={14} />
            <span>
                <strong>Stale content:</strong> Last reviewed {daysSince} days ago ({new Date(lastReviewedAt).toLocaleDateString()}).
                Please verify this information is still accurate.
            </span>
        </div>
    );
}